import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Button from '@material-ui/core/Button'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from '../../contexts/i18n/use'
import { useHistory } from 'react-router-dom'
import { useConfig } from '../../contexts/config/use'

export const QueueCheckinItem = ({officeID, disabled, disablecallback, enableSneakySound}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const { actions: {GetUrlIDFromOfficeID}} = useConfig();
  const { actions: {t, ct}} = useTranslation();

  const handleSubmit = () => {
    disablecallback(true);
    localStorage.setItem("selectedqueuename", t('checkinpage.checkin'));
    enableSneakySound();
    history.push("checkin?officeID=" + GetUrlIDFromOfficeID(officeID));
      return;
  }

  return (
    <ListItem className={[classes.container, "queues-listitems"].join(' ')} classes={{root: classes.root}}> 
      <ListItemText
        primary={
         <Typography 
            component="span" 
            variant="body1" 
            className={[classes.primarytext, "queues-listitems-text-primary"].join(' ')}
            id={"queues-checkinitem-text"}
         >
            { ct(officeID, "name") }
         </Typography>}
      />
      <Button 
         size="large" 
         className={[classes.button, "queues-listitems-buttons"].join(' ')} 
         id={"queues-checkinitem-button"}
         onClick={handleSubmit} 
         disabled={disabled} >
         { <Typography 
            className="queues-listitems-buttons-text"
            id="queues-checkinitem-button-text"
            >
               {t('queuepage.checkinbutton') || "Köa"}
            </Typography>
         }
      </Button>
    </ListItem>
  ) 
}

const useStyles = makeStyles({
  container: theme => ({
    maxWidth: '500px',
    backgroundColor: theme.palette.listitem.main,
    paddingTop: '0.25rem',
    paddingBottom: 0
  }),
  button: theme => ({
    borderRadius: 0,
    color: theme.palette.button_text.main,
    backgroundColor: theme.palette.primary.main,
    padding: '0.8rem 0.5rem',
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  primarytext: theme => ({
    color: theme.palette.primary.main
  }),
  secondarytext: theme => ({
    color: theme.palette.secondary_text.main
  }),
  root: {
    margin: '0.25rem 0 0.25rem'
  }
})